import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '../../../services/auth.service';
import { ComponentService, CreatorFrontApi } from '../../../services/component.service';
import { OverlayService } from '../../../services/overlay.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { NewApiHttpService, NewApiResponse } from '../../../services/new-api-http.service';
import { TimezoneService, Timezone } from '../../../services/timezone.service';
import { COMPONENTS_TEMPLATES } from '../../../data/component-templates-config';

@Component({
	selector: 'app-web-scrape',
	templateUrl: './web-scrape.component.html',
	styleUrls: ['./web-scrape.component.scss']
})
export class WebScrapeComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('webscrapeForm', { static: true }) webscrapeForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	webscrapeFormSubscription: Subscription;
	isPreviewPromiseCompleted: Boolean = false;
	scrapePreviewSubscription: Subscription;
	isModalShown = false;
	modalHeight = window.innerHeight * 0.85;
	newapi = false;
	linkURL = '{{linkURL}}';
	imageURL = '{{imageURL}}';
	template = '{{template}}';
	isAdmin;
	timezone: string;
	timezones: Array<Timezone>;
	localOffset: number;

	constructor(
		private comService: ComponentService,
		private overlay: OverlayService,
		private auth: AuthService,
		private sanitation: DomSanitizer,
		private newApiHttpService: NewApiHttpService,
		private tz: TimezoneService
	) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();
		this.newapi = this.componentData.config.version > 1 && this.componentData.config.newapi;
		this.timezones = this.tz.getTimezones();

		if (this.newapi && typeof this.componentData.config.timestamp === 'undefined') {
			this.componentData.config.timestamp = COMPONENTS_TEMPLATES['web-scrape'][0].config.timestamp;
		}

		this.webscrapeFormSubscription = this.webscrapeForm.valueChanges
			.pipe(
				tap(() =>
					this.comService.updateDisabledSave(
						(this.webscrapeForm.dirty && this.webscrapeForm.invalid) || this.nameField.editComponentName
					)
				),
				filter((form) => this.webscrapeForm.dirty && this.webscrapeForm.valid),
				debounceTime(2000)
			)
			.subscribe();
	}

	ngOnDestroy() {
		this.webscrapeFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}

	newScrapePreview() {
		const data = {
			name: this.componentData.name,
			legacy: this.componentData.legacy,
			config: JSON.stringify(this.componentData.config)
		};

		this.overlay.updateOverlay(true, 'This may take up to 25 seconds to load...');

		if (this.scrapePreviewSubscription) {
			this.scrapePreviewSubscription.unsubscribe();
		}

		this.scrapePreviewSubscription = this.newApiHttpService.newApiRequestPost('widget/preview', data).subscribe(
			(response: CreatorFrontApi) => {
				const respError =
					response && response.error
						? response.error
						: `Ugh, it looks like this component preview is not accessible.
                   Please contact dmsupport@optimove.com if you need help.`;

				if (response && response.status) {
					const regex = /<img.*?src="(.*?)"/;
					let src = regex.exec(response.data.snippet)[1];
					let previewUrl = src.replace('webscraper_image.png', 'preview_webscraper_image.png');
					previewUrl = previewUrl.replace('http://localhost:3016/', 'https://dm-assets-dev.optimove.net/');

					this.componentData.config.fullScreenCaptureUrl = previewUrl;
					this.componentData.config.fullScreenCapture = this.sanitation.bypassSecurityTrustStyle(`url(${previewUrl})`);
					this.componentData.config.fullscreenImage = this.sanitation.bypassSecurityTrustStyle(`url(${previewUrl})`);

					this.overlay.updateOverlay(false);
				} else {
					this.overlay.updateOverlay(true, respError, 'alert');
				}
			},
			(err) => {
				this.overlay.updateOverlay(true, err, 'alert');
			}
		);
	}

	openWebScrapePopup() {
		if (this.newapi) {
			if (this.componentData.config.selector) {
				this.overlay.updateOverlay(true, 'A custom selector is being used so button is disabled', 'alert');
			} else {
				this.isModalShown = true;
				this.newScrapePreview();
			}
		} else {
			this.isModalShown = true;
			const userId = this.auth.getUser().id;
			const data = { source: this.componentData.config.source, userId: userId, config: JSON.stringify(this.componentData.config) };

			this.newApiHttpService.newApiRequestGet('legacy-function/getScreenCaptureLink', data).subscribe((response: NewApiResponse) => {
				if (response && response.status) {
					this.componentData.config.fullScreenCapture = this.sanitation.bypassSecurityTrustStyle(
						'url(' + response.data.URL + '?full_size) 0 0 no-repeat'
					);
					this.componentData.config.fullscreenImage = this.sanitation.bypassSecurityTrustStyle(
						'url(' + response.data.URL + '?full_size)'
					);
					this.componentData.config.fullScreenHeight = response.data.height;
				}
				this.overlay.updateOverlay(false);
			});
		}
	}

	processReturnedData(event) {
		this.isModalShown = false;
		if (event.method === 'update') {
			this.componentData = event.data;
			this.brodcastToPreview();
		}
	}

	removeCron(event) {
		if (event) {
			delete this.componentData.config.crontag;
			delete this.componentData.config.cronfrequency;
		} else {
			this.componentData.config.crontag = 'webscrape';
		}
	}
}
